import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
// The only file that calls this component is App.js
const RequireAuth = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  return currentUser?.accessToken ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
};

export default RequireAuth;
